module.exports = __webpack_public_path__ + "img/49_14.9d2046cb.png";